"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletV1SigningMessage = void 0;
const Cell_1 = require("../../boc/Cell");
class WalletV1SigningMessage {
    constructor(args) {
        this.order = args.order;
        this.sendMode = args.sendMode;
        if (args.seqno !== undefined && args.seqno !== null) {
            this.seqno = args.seqno;
        }
        else {
            this.seqno = 0;
        }
    }
    writeTo(cell) {
        cell.bits.writeUint(this.seqno, 32);
        cell.bits.writeUint8(this.sendMode);
        // Write order
        let orderCell = new Cell_1.Cell();
        this.order.writeTo(orderCell);
        cell.refs.push(orderCell);
    }
}
exports.WalletV1SigningMessage = WalletV1SigningMessage;
